module.exports = __webpack_public_path__ + "media/frontend/base/typo/fonts/NeoSansRegular-web-e1856f46409c0ca2a7883c449e77f1f7.woff2";